// extracted by mini-css-extract-plugin
module.exports = {"BuildControl":"buildControl_BuildControl__3HFw_","Label":"buildControl_Label__jj0TB","Less":"buildControl_Less__1s7yT","More":"buildControl_More__1ChfT"};